import {Record} from 'immutable';

import {type ActivityFragment} from 'web-app/react/activities/__generated__/queries.api-types';
import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';

export interface ActivityLibrarySettingFormModalStateProps {
    readonly show: boolean;
    readonly institutionId?: string;
    readonly activityId?: string;
    readonly refetchQueries?: any[];
    readonly successAction?: (activity: ActivityFragment) => void;
}

export class ActivityLibrarySettingFormModalState extends Record<ActivityLibrarySettingFormModalStateProps>({
    show: false,
    institutionId: undefined,
    activityId: undefined,
    refetchQueries: [],
    successAction: undefined,
}) {}

export default makeReducer<ActivityLibrarySettingFormModalState>(
    [
        match(Actions.show, (state, {payload}) => {
            return state.merge({
                show: payload.show,
                activityId: payload.activityId,
                institutionId: payload.institutionId,
                refetchQueries: payload.refetchQueries,
                successAction: payload.successAction,
            });
        }),
    ],
    new ActivityLibrarySettingFormModalState(),
);
